import React from 'react';

import {AggregatorHero} from '@udemy/browse-aggregator';
import {I18nApi, useI18n} from '@udemy/i18n';

export const CERTIFICATION_PREPARATION_TITLE = (gettext: I18nApi['gettext']) =>
    gettext('Certification Preparation');

export const AggregatorHeroWrapper = () => {
    const {gettext} = useI18n();
    const _CERTIFICATION_PREPARATION_TITLE = CERTIFICATION_PREPARATION_TITLE(gettext);
    const CERTIFICATION_PREPARATION_DESCRIPTION = gettext(
        'Udemy provides specialized courses in IT, business, and project management, designed by experts to prepare learners for certification exams offered by third parties. These affordable courses feature flexible, interactive learning and practice exams to ensure success.',
    );

    /**
     * Show more can create hydration problems and since we don't have
     * dom on server side, it's rendering show more button no matter what because it doesn't know if it's overflow or not.
     *
     * Just hide the show more on server side.
     */
    return (
        <AggregatorHero
            title={_CERTIFICATION_PREPARATION_TITLE}
            description={CERTIFICATION_PREPARATION_DESCRIPTION}
            learnMoreUrl={''}
            breadcrumbs={[]}
            showLearnerContext={false}
            useShowMore={false}
        />
    );
};
